<template>
<div>
    <div v-if="!isMobile">
        
        <div class="div_001">
            <div class="div_001_001">
                <div @click="nav_001('')"></div>
                <div>
                    <div @click="nav_001('Features')">     Features     </div>
                    <div @click="nav_001('Applications')"> Applications </div>
                    <div @click="nav_001('Projects')">     Projects     </div>
                    <div @click="nav_001('About')">        About Us     </div>
                    <div @click="nav_001('Contact')">      Contact Us   </div>
                </div>
                <div>
                    <div></div> <div> EN </div>
                </div>
            </div>
        </div>
        
        <div class="div_002">
            <div class="div_002_001">
                <div @click="nav_001('')"></div> <div><div><div></div></div></div> <div> Projects </div>
            </div>
        </div>
        
        <div class="div_003" :style="{ 'height' : screenHeight - 168 + 'px' }">
            <div class="div_003_001">
                <div :style="{ 'height' : screenHeight - 200 + 'px' }">
                    
                    <div class="div_003_001_m"></div>
                    
                    <div class="div_003_001_l">
                        <div></div> <span>Learn more</span>
                    </div>
                    
                    <div class="div_003_001_r">
                        <div class="iconfont_002"> A New Material Language </div>
                        <div class="iconfont_002"> for Public Spaces </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="div_004">
            <div class="div_004_001">
                <div>
                    <div class="div_004_001_l">
                        <div class="div_image_001" @click="nav_001('Projects/Project/CBD Fair Booth Project&image_001.png')"></div>
                        <div class="div_first_001"> <div></div> <span> CBD Fair Booth Project </span> <span> | </span> <div></div> <span> Guangzhou </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                    <div class="div_004_001_r">
                        <div class="div_image_002" @click="nav_001('Projects/Project/Case 02&image_002.png')"></div>
                        <div> <div></div> <span> Case 02 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                </div>
                <div>
                    <div class="div_004_001_l">
                        <div class="div_image_003" @click="nav_001('Projects/Project/Case 03&image_003.png')"></div>
                        <div> <div></div> <span> Case 03 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                    <div class="div_004_001_r">
                        <div class="div_image_004" @click="nav_001('Projects/Project/Case 04&image_004.png')"></div>
                        <div> <div></div> <span> Case 04 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                </div>
                <div>
                    <div class="div_004_001_l">
                        <div class="div_image_005" @click="nav_001('Projects/Project/Case 05&image_005.png')"></div>
                        <div> <div></div> <span> Case 05 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                    <div class="div_004_001_r">
                        <div class="div_image_006" @click="nav_001('Projects/Project/Case 06&image_006.png')"></div>
                        <div> <div></div> <span> Case 06 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    
    <div v-if="isMobile">
        
        <div class="div_mobile_001">
            <div class="div_mobile_001_001">
                <div class="div_mobile_001_001_l" @click="nav_001('')"></div>
                <div class="div_mobile_001_001_r" @click="fun_002()">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        
        <div id="div_mobile_menu" class="div_mobile_menu" :style="{ height: screenHeight + 'px', top: -screenHeight + 'px' }">
            <div @click="nav_001('Features')">     Features     </div>
            <div @click="nav_001('Applications')"> Applications </div>
            <div @click="nav_001('Projects')">     Projects     </div>
            <div @click="nav_001('About')">        About Us     </div>
            <div @click="nav_001('Contact')">      Contact Us   </div>
            <div :style="{ 'height' : screenHeight - 438 + 'px' }"  @click="fun_002()"></div>
        </div>
        
        <div class="div_mobile_002">
            <div class="div_mobile_002_001">
                <div @click="nav_001('')"></div> <div><div><div></div></div></div> <div> Projects </div>
            </div>
        </div>
        
        <div class="div_mobile_003">
            <div class="div_mobile_003_001">
                <div>
                    
                    <div class="div_mobile_003_001_m"></div>
                    
                    <div class="div_mobile_003_001_l">
                        <div></div> <span>Learn more</span>
                    </div>
                    
                    <div class="div_mobile_003_001_r">
                        <div class="iconfont_002"> A New Material Language </div>
                        <div class="iconfont_002"> for Public Spaces </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="div_mobile_004">
            <div class="div_mobile_004_001">
                <div>
                    <div class="div_mobile_004_001_l">
                        <div class="div_mobile_image_001" @click="nav_001('Projects/Project/CBD Fair Booth Project&image_001.png')"></div>
                        <div> <div></div> <span> CBD Fair Booth Project </span> <span> | </span> <div></div> <span> Guangzhou </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                    <div class="div_mobile_004_001_r">
                        <div class="div_mobile_image_002" @click="nav_001('Projects/Project/Case 02&image_002.png')"></div>
                        <div> <div></div> <span> Case 02 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                </div>
                <div>
                    <div class="div_mobile_004_001_l">
                        <div class="div_mobile_image_003" @click="nav_001('Projects/Project/Case 03&image_003.png')"></div>
                        <div> <div></div> <span> Case 03 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                    <div class="div_mobile_004_001_r">
                        <div class="div_mobile_image_004" @click="nav_001('Projects/Project/Case 04&image_004.png')"></div>
                        <div> <div></div> <span> Case 04 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                </div>
                <div>
                    <div class="div_mobile_004_001_l">
                        <div class="div_mobile_image_005" @click="nav_001('Projects/Project/Case 05&image_005.png')"></div>
                        <div> <div></div> <span> Case 05 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                    <div class="div_mobile_004_001_r">
                        <div class="div_mobile_image_006" @click="nav_001('Projects/Project/Case 06&image_006.png')"></div>
                        <div> <div></div> <span> Case 06 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span> </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isMobile     : false,
            screenHeight : 0,
            scrollTop    : 0,
        };
    },
    created() {
        // 监听；
        window.addEventListener('resize', this.checkIsMobile);
        // window.addEventListener('scroll', this.checkScrollTop);
    },
    mounted() {
        let that = this;
        
        document.title = '';
        
        this.checkIsMobile();
        this.checkScreenHeight();
    },
    destroyed() {
        window.removeEventListener('resize', this.checkIsMobile);
        // window.removeEventListener('scroll', this.checkScrollTop);
    },
    methods: {
        // 检测移动设备；
        checkIsMobile() {
            const width = window.innerWidth || document.documentElement.clientWidth;
            let isMobile_001 = width <= 768;
            
            const userAgent = window.navigator.userAgent;
            let isMobile_002 = /iPhone|iPad|iPod|Android/i.test(userAgent);
             
            this.isMobile = isMobile_001 || isMobile_002;
            
            // console.log("移动设备判断方式一：", isMobile_001);
            // console.log("移动设备判断方式二：", isMobile_002);
        },
        // 检测屏幕高度；
        checkScreenHeight() {
            const height = window.innerHeight || document.documentElement.clientHeight;
            this.screenHeight = height;
        },
        // 事件 - 导航栏跳转；
        nav_001( param ) {
            this.$router.push( "/" + param );
        },
        // 事件 - 移动端导航栏；
        fun_002( ) {
            
            let that = this;
            
            let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
            
            console.log(offset);
            
            if ( offset < 0 ) {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) + 10 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] >= 0 ) {
                        
                        document.getElementById( 'div_mobile_menu' ).style.top = '0px';
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            } else {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) - 10 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] <= -that.screenHeight ) {
                    
                        document.getElementById( 'div_mobile_menu' ).style.top = -that.screenHeight;
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            }
        },
    }
};
</script>

<style scoped>
/*** ************************************************* ***/

.div_001 {
    width: 100%;
    height: 88px;
    
    color: #F7F4EC;
    background-color: #151513;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_001_001 {
    width: 1440px;
    height: 100%;
    
    background-color: #151513;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: relative;
}

.div_001_001 > div:first-child {
    width: 137px;
    height: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: absolute;
    top: 28px;
    left: 32px;
}

.div_001_001 > div:nth-child(2) {
    width: 885px;
    
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_001_001 > div:nth-child(2) > div {
    cursor: pointer;
}

.div_001_001 > div:last-child {
    width: 54px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    position: absolute;
    top: 32px;
    right: 32px;
}

.div_001_001 > div:last-child > div:first-child {
    width: 20px;
    height: 20px;
    
    background-image : url('../assets/image_000_003.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
    top: 0.5px;
}

.div_001_001 > div:last-child > div:last-child {
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_002 {
    width: 100%;
    height: 168px;
    
    color: #F7F4EC;
    background-color: #151513;
}

.div_002_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_002_001 > div:first-child {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_005.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_002_001 > div:nth-child(2) {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 22px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_002_001 > div:nth-child(2) > div {
    width : 0px;
    height: 0px;
    
    border-top : 8px solid transparent;
    border-left : 8px solid #F7F4EC;
    border-right : 8px solid transparent;
    border-bottom : 8px solid transparent;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    position: relative;
}

.div_002_001 > div:nth-child(2) > div > div {
    width : 0px;
    height: 0px;
    
    border-top : 5px solid transparent;
    border-left : 5px solid #151513;
    border-right : 5px solid transparent;
    border-bottom : 5px solid transparent;
    
    position: absolute;
    left: -8px;
}

.div_002_001 > div:last-child {
    width : 200px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 120px;
    margin-left: 5px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/*** ************************************************* ***/

.div_003 {
    width: 100%;
    background-color: #151513;
}

.div_003_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0 auto;
}

.div_003_001 > div {
    width: 1376px;
    
    margin: 0 auto;
    border-radius: 10px;
    
    background-image : url('../assets/04 Projects/cover.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
}

.div_003_001_l {
    width : 400px;
    height: 140px;
    
    color: #2F2F2F;
    font-size: 16px;
    font-weight: 500;
    
    color: #F7F4EC;
    background-color: #151513;
    
    clip-path: polygon(0 0, 0 100%, 100% 100%);
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-end;
    
    position: absolute;
    bottom: 0;
    left: 0;
}

.div_003_001_l > div {
    width : 24px;
    height: 24px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_006.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_003_001_l > span {
    margin-left: 12px;
    margin-bottom: 2.5px;
    cursor: pointer;
}

.div_003_001_r {
    width : 550px;
    height: 104px;
    
    color: #F7F4EC;
    
    font-size: 36px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-around;
    align-items : flex-end;
    
    position: absolute;
    bottom: 45px;
    right: 40px;
}

.div_003_001_m {
    width : 100%;
    height: 100%;
    
    background-color: rgba(0, 0, 0, 0.2);
    
    position: absolute;
    top: 0px;
    left: 0px;
}

/*** ************************************************* ***/

.div_004 {
    width: 100%;
    height: 1493px;
    
    color: #F7F4EC;
    
    background-color: #151513;
}

.div_004_001 {
    width: 1032px;
    height: 100%;
    
    margin: 0px auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_004_001 > div {
    width: 1032px;
    height: 423px;
    
    margin-top: 32px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_004_001_l,
.div_004_001_r{
    width: 500px;
    height: 423px;
    
    margin-top: 32px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_004_001_l > div:first-child,
.div_004_001_r > div:first-child {
    width: 500px;
    height: 375px;
    
    cursor: pointer;
    
    border-radius: 8px;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_image_001 {
    background-image : url('../assets/04 Projects/image_001.png');
    background-size : 130% !important;
    border-radius: 15px !important;
}

.div_image_002 {
    background-image : url('../assets/04 Projects/image_002.png');
}

.div_image_003 {
    background-image : url('../assets/04 Projects/image_003.png');
}

.div_image_004 {
    background-image : url('../assets/04 Projects/image_004.png');
}

.div_image_005 {
    background-image : url('../assets/04 Projects/image_005.png');
}

.div_image_006 {
    background-image : url('../assets/04 Projects/image_006.png');
    background-size : 115% !important;
    border-radius: 15px !important;
}

.div_004_001_l > div:last-child,
.div_004_001_r > div:last-child {
    width: 60%;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    align-self: flex-start;
}

.div_first_001 {
    width: 80% !important;
}

.div_004_001_l > div:last-child > div:first-child,
.div_004_001_r > div:last-child > div:first-child{
    width: 24px;
    height: 24px;
    
    background-image : url('../assets/04 Projects/icon_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_004_001_l > div:last-child > div:nth-child(4),
.div_004_001_r > div:last-child > div:nth-child(4){
    width: 24px;
    height: 24px;
    
    background-image : url('../assets/04 Projects/icon_002.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 70%;
}

/*** ************************************************* ***/
/*** ************************************************* ***/

.div_mobile_001 {
    width: 100%;
    height: 88px;
    
    background-color: #151513;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_mobile_001_001 {
    width: 90%;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_001_001_l {
    width: 137px;
    height: 32px;
    
    background-image : url('../assets/image_000_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_001_001_r {
    width: 40px;
    height: 40px;
    
    background-color: #F7F4EC;
    
    border-radius: 4px;
        
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_001_001_r > div {
    width: 28px;
    height: 3px;
    
    margin-top: 2.5px;
    margin-bottom: 2.5px;
    
    border-radius: 2px;
    
    background-color: #151513;
}

.div_mobile_menu {
    width: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    position: fixed;
    left: 0px;
    
    z-index: 999999;
}

.div_mobile_menu > div {
    width: 100%;
    height: 70px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    
    background-color: #F7F4EC;
}

.div_mobile_menu > div:first-child {
    margin-top: 88px;
}

.div_mobile_menu > div:last-child {
    width: 100%;
    
    background-color: rgba(0, 0, 0, 0);
}

/*** ************************************************* ***/

.div_mobile_002 {
    width: 100%;
    height: 168px;
    
    color: #F7F4EC;
    background-color: #151513;
}

.div_mobile_002_001 {
    width: 90%;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_002_001 > div:first-child {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_005.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_002_001 > div:nth-child(2) {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 22px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_002_001 > div:nth-child(2) > div {
    width : 0px;
    height: 0px;
    
    border-top : 8px solid transparent;
    border-left : 8px solid #F7F4EC;
    border-right : 8px solid transparent;
    border-bottom : 8px solid transparent;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    position: relative;
}

.div_mobile_002_001 > div:nth-child(2) > div > div {
    width : 0px;
    height: 0px;
    
    border-top : 5px solid transparent;
    border-left : 5px solid #151513;
    border-right : 5px solid transparent;
    border-bottom : 5px solid transparent;
    
    position: absolute;
    left: -8px;
}

.div_mobile_002_001 > div:last-child {
    width : 200px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 120px;
    margin-left: 5px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/*** ************************************************* ***/

.div_mobile_003 {
    width: 100%;
    height: 520px;
    background-color: #151513;
}

.div_mobile_003_001 {
    width: 100%;
    height: 100%;
    
    margin: 0 auto;
}

.div_mobile_003_001 > div {
    width: 90%;
    height: 500px;
    
    margin: 0 auto;
    border-radius: 10px;
    
    background-image : url('../assets/04 Projects/cover.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 150%;
    
    position: relative;
}

.div_mobile_003_001_l {
    width : 250px;
    height: 100px;
    
    color: #2F2F2F;
    font-size: 16px;
    font-weight: 500;
    
    color: #F7F4EC;
    background-color: #151513;
    
    clip-path: polygon(0 0, 0 100%, 100% 100%);
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-end;
    
    position: absolute;
    bottom: 0;
    left: 0;
}

.div_mobile_003_001_l > div {
    width : 24px;
    height: 24px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_006.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_003_001_l > span {
    margin-left: 12px;
    margin-bottom: 2.5px;
    cursor: pointer;
}

.div_mobile_003_001_r {
    width : 340px;
    height: 60px;
    
    position: absolute;
    bottom: 100px;
    right: 10px;
    
    color: #F7F4EC;
    
    font-size: 22px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-around;
    align-items : flex-end;
}

.div_mobile_003_001_m {
    width : 100%;
    height: 100%;
    
    background-color: rgba(0, 0, 0, 0.2);
    
    position: absolute;
    top: 0px;
    left: 0px;
}

/*** ************************************************* ***/

.div_mobile_004 {
    width: 100%;
    
    color: #F7F4EC;
    
    background-color: #151513;
}

.div_mobile_004_001 {
    width: 90%;
    height: 100%;
    
    margin: 0px auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_004_001 > div {
    width: 100%;
    
    margin-top: 10px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_004_001 > div:last-child {
    margin-bottom: 50px;
}

.div_mobile_004_001_l,
.div_mobile_004_001_r{
    width: 300px;
    height: 323px;
    
    margin-top: 30px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_004_001_l > div:first-child,
.div_mobile_004_001_r > div:first-child {
    width: 300px;
    height: 275px;
    
    cursor: pointer;
    
    border-radius: 8px;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_image_001 {
    background-image : url('../assets/04 Projects/image_001.png');
    background-size : 160% !important;
    border-radius: 15px !important;
}

.div_mobile_image_002 {
    background-image : url('../assets/04 Projects/image_002.png');
}

.div_mobile_image_003 {
    background-image : url('../assets/04 Projects/image_003.png');
}

.div_mobile_image_004 {
    background-image : url('../assets/04 Projects/image_004.png');
}

.div_mobile_image_005 {
    background-image : url('../assets/04 Projects/image_005.png');
}

.div_mobile_image_006 {
    background-image : url('../assets/04 Projects/image_006.png');
    background-size : 140% !important;
    border-radius: 15px !important;
}

.div_mobile_004_001_l > div:last-child,
.div_mobile_004_001_r > div:last-child {
    width: 100%;
    height: 24px;
    
    font-size: 12px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    align-self: flex-start;
}

.div_mobile_004_001_l > div:last-child > div:first-child,
.div_mobile_004_001_r > div:last-child > div:first-child{
    width: 20px;
    height: 20px;
    
    background-image : url('../assets/04 Projects/icon_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_004_001_l > div:last-child > div:nth-child(4),
.div_mobile_004_001_r > div:last-child > div:nth-child(4){
    width: 20px;
    height: 20px;
    
    background-image : url('../assets/04 Projects/icon_002.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 70%;
}

/*** ************************************************* ***/
</style>